import { Box, FlexLayout } from '@deity/falcon-ui';
import { mapRecord } from '@deity-io/di-data-basics';
import { Checkbox } from '@deity-io/portal-ui';
import { FlowContext } from 'contexts/FlowContext';
import { useContext, useState } from 'react';
import ReactJson from 'react-json-view';

const filterJson = (input: any, filterKey: string): any => {
  switch (typeof input) {
    case 'object':
      if (Array.isArray(input)) {
        return input.map(item => filterJson(item, filterKey));
      }

      return mapRecord(input, (item, key) => (key === filterKey ? undefined : filterJson(item, filterKey)));
    case 'symbol':
    case 'undefined':
      return undefined;
    default:
      return input;
  }
};

const JSONPreview = () => {
  const ctx = useContext(FlowContext);
  const [useFilter, setUseFilter] = useState<boolean>(true);
  const data = useFilter ? filterJson(ctx?.state.flowSchema, 'editor') : ctx?.state.flowSchema;

  return (
    <FlexLayout>
      {data && (
        <Box p="xs" style={{ overflow: 'auto' }} width="full">
          <Checkbox
            checked={useFilter}
            label="Hide editor settings"
            onChange={e => {
              setUseFilter(e.target.checked);
            }}
          />
          <ReactJson src={data} name={null} theme="ashes" collapseStringsAfterLength={18} />
        </Box>
      )}
    </FlexLayout>
  );
};

export default JSONPreview;
